module.exports = __webpack_public_path__ + "static/education_card_img3@2x-e3f55abe90ce2de994903a2e8accbde1.jpg";